import { Reveal, Eyebrow } from "@/lib/motion";
import { Route, ClipboardCheck, LayoutDashboard, MessagesSquare } from "lucide-react";

const CAPS = [
  {
    icon: Route,
    title: "AI Task Router",
    body: "Work gets assigned the moment it lands — by role, workload, urgency, and SLA — with zero manual triage.",
  },
  {
    icon: ClipboardCheck,
    title: "SOP Automation",
    body: "Every process runs the same way every time: required steps, automatic reminders, and a compliance trail your auditors will actually like.",
  },
  {
    icon: LayoutDashboard,
    title: "Workflow Dashboards",
    body: "See every bottleneck, SLA breach, and stuck queue in real time — before it becomes a customer-facing problem.",
  },
  {
    icon: MessagesSquare,
    title: "AI Communication Agents",
    body: "“Status?” “Handoff?” “Who owns this?” — RelayOps answers the loop so your team doesn’t have to.",
  },
];

export default function Capabilities() {
  return (
    <section id="product" className="relative bg-bg-surface/45 py-24 backdrop-blur-sm lg:py-32">
      <div className="container-max band-pad">
        <div className="max-w-2xl">
          <Reveal>
            <Eyebrow testId="product-eyebrow">The product</Eyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-4xl lg:text-5xl">
              An ops layer, not another inbox.
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-x-12 gap-y-14 md:grid-cols-2">
          {CAPS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.06}>
              <div
                data-testid={`capability-${i}`}
                className="group border-t border-hairline pt-7"
              >
                <div className="flex items-start gap-5">
                  <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl border border-hairline bg-bg-primary/50 text-signal transition-colors duration-300 group-hover:border-signal/40 group-hover:bg-signal/10">
                    <c.icon size={22} strokeWidth={1.75} />
                  </span>
                  <div>
                    <h3 className="font-display text-xl font-semibold text-ink">
                      {c.title}
                    </h3>
                    <p className="mt-3 max-w-md leading-relaxed text-ink-muted">
                      {c.body}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
